/* Signage.inc redesign - sign categories, sign type cards, quote form.
   Everything category related is rendered from window.SG_SIGN_DATA (assets/sg-sign-categories.js),
   so an edit there updates the home page, the categories page, every category page and the quote page.

   Render hooks (put these on elements in sections):
     data-sg-render="category-grid"   category cards; add data-inplace to open sign types in place (quote page)
     data-sg-render="sign-grid"       sign type cards of the current category
     data-sg-render="cat-whys"        "why choose" checklist of the current category
     data-sg-render="cat-faqs"        FAQ of the current category
     data-sg-render="cat-links"       <li> links to every category (footer)
     data-sg-render="strip"           moving photo strip (current category, or all categories); data-cases = real
                                      case study photos (assets/sg-case-strip.js) opening their case study
     data-sg-tpl="..."                text with {name} {sub} {intro} {h1} {h1em} {count} {total}; *x* = <em>x</em>
     data-sg-img="hero|cover"         category image (img element)
     data-sg-href="quote"             link to the quote page for the current category
   The current category comes from data-sg-cat (category hero "Fixed category id"), then ?cat=<id>, then the page handle. */
(function () {
  'use strict';
  var doc = document;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var SG = window.SG || {};
  var DATA = window.SG_SIGN_DATA || { categories: [], types: {}, gallery: {}, images: {} };
  var URLS = SG.urls || {};

  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function arrowR() { return '<svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;stroke-width:2.5;fill:none;stroke-linecap:round;stroke-linejoin:round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'; }
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12.5l2.8 2.8L16 9.5"/></svg>';

  /* =========================================================================
     DATA HELPERS
     ========================================================================= */
  /* Images in assets/sg-sign-categories.js are complete URLs (any host, any format), used exactly as written.
     Small spots (sign cards, strip) ask Shopify-hosted images for a 640px version via Shopify's ?width=;
     other hosts are left untouched. Old short names (e.g. "reception-logo") still resolve to Shopify Files. */
  var SMALL = 640;
  function isUrl(k) { return /^(https?:)?\/\//i.test(k); }
  function isShopifyCdn(u) { return /(^|\/\/)cdn\.shopify\.com\/|\/cdn\/shop\//i.test(u); }
  function imgUrl(key, sm) {
    var u = isUrl(key) ? key : (SG.assetBase || '') + 'sg-' + key + '.webp';
    if (sm && isShopifyCdn(u) && !/[?&]width=/.test(u)) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + SMALL;
    return u;
  }
  function img(key, alt, o) {
    o = o || {};
    var d = DATA.images[key] || [], w = d[0], h = d[1];
    var src = imgUrl(key, o.sm !== false);
    if (w && o.sm !== false && src !== key && /[?&]width=/.test(src) && w > SMALL) { h = Math.round(h * SMALL / w); w = SMALL; }
    return '<img src="' + esc(src) + '"' + (w ? ' width="' + w + '" height="' + h + '"' : '') +
      ' alt="' + esc(alt) + '"' + (o.cls ? ' class="' + o.cls + '"' : '') + (o.lazy === false ? '' : ' loading="lazy" decoding="async"') + '>';
  }
  function findCat(id) {
    if (!id) return null;
    id = String(id).toLowerCase();
    for (var i = 0; i < DATA.categories.length; i++) {
      var c = DATA.categories[i];
      if (c.id === id || (c.aliases || []).indexOf(id) > -1) return c;
    }
    return null;
  }
  function currentCat(scope) {
    var host = (scope && scope.closest ? scope.closest('[data-sg-cat]') : null) || $('[data-sg-cat]');
    var fixed = host && host.getAttribute('data-sg-cat');
    if (fixed) return findCat(fixed);
    var q = window.URLSearchParams ? new URLSearchParams(location.search).get('cat') : null;
    return findCat(q) || findCat(SG.pageHandle);
  }
  function catUrl(c) { return (URLS.category || '/pages/sign-category') + '?cat=' + encodeURIComponent(c.id); }
  function quoteUrl(params) {
    var u = URLS.quote || '/pages/get-a-quote', q = [];
    Object.keys(params || {}).forEach(function (k) { if (params[k]) q.push(k + '=' + encodeURIComponent(params[k])); });
    return u + (q.length ? (u.indexOf('?') > -1 ? '&' : '?') + q.join('&') : '');
  }
  /* sign type as shown inside a category: shared type + the category's overrides */
  function resolveItem(item) {
    var t = DATA.types[item.type] || {};
    return { id: item.type, name: item.name || t.name, img: item.img || t.img, desc: item.desc || t.desc, tags: t.tags || [], gallery: item.gallery };
  }
  function galleryKeys(tid, first) {
    var out = [first];
    (DATA.gallery[tid] || []).forEach(function (k) { if (out.indexOf(k) < 0) out.push(k); });
    return out;
  }
  function fill(tpl, c) {
    var total = DATA.categories.length;
    var s = esc(tpl).replace(/\{(\w+)\}/g, function (m, k) {
      if (k === 'count') return c ? c.types.length : '';
      if (k === 'total') return total;
      return c && c[k] != null ? esc(c[k]) : '';
    });
    return s.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  }

  /* =========================================================================
     MARKUP (mirrors the redesign's build.py)
     ========================================================================= */
  function catCard(c, inplace) {
    var tag = inplace ? 'div' : 'a';
    var attrs = inplace
      ? 'data-cat="' + esc(c.id) + '" data-href="' + esc(catUrl(c)) + '" role="button" tabindex="0" aria-expanded="false"'
      : 'href="' + esc(catUrl(c)) + '"';
    var btn = inplace
      ? '<button type="button" class="cat-card-btn" tabindex="-1">Explore Types ' + arrowR() + '</button>'
      : '<span class="cat-card-btn">Explore Types ' + arrowR() + '</span>';
    return '<' + tag + ' class="cat-card" ' + attrs + '>' +
      '<div class="cat-card-img"><span class="cat-card-count"><b>' + c.types.length + '</b> sign types</span>' +
      img(c.cardImg || c.cover, c.name + ' by Signage.inc', { sm: false }) +
      '<div class="cat-card-name">' + esc(c.name) + '<span class="cat-card-sub">' + esc(c.sub) + '</span></div></div>' +
      '<div class="cat-card-body"><span class="cat-card-eyebrow" aria-hidden="true">' + esc(c.sub) + '</span><p class="cat-card-desc">' + esc(c.cardDesc) + '</p>' + btn + '</div></' + tag + '>';
  }

  var uidSeq = 0;
  function signCard(item, c) {
    var t = resolveItem(item), uid = 'sg' + (++uidSeq);
    var lit = t.tags[0] === 'Lit';
    /* "View Designs": the category's own gallery for this sign type if it has one, else the shared one */
    var keys = t.gallery ? [t.img].concat(t.gallery.filter(function (k) { return k !== t.img; })) : galleryKeys(t.id, t.img);
    var gallery = keys.map(function (k) { return imgUrl(k, false); });   /* every photo; the thumbnail row scrolls */
    var tags = t.tags.map(function (x) { return '<span class="sign-tag">' + esc(x) + '</span>'; }).join('');
    var nq = esc(t.name);
    return '<div class="sign-card-wrap" data-sign="' + nq + '" data-cat="' + esc(c.name) + '" data-type="' + esc(t.id) + '"><div class="sign-card-inner">' +
      '<div class="sign-card-face sign-card-front"><div class="sign-card"><div class="sign-card-img-wrap">' +
      img(t.img, t.name + ' by Signage.inc', { cls: 'sign-card-img' }) +
      '<span class="sign-badge ' + (lit ? 'badge-lit' : 'badge-outdoor') + '">' + (lit ? 'Lit' : 'Non-Lit') + '</span></div>' +
      '<div class="sign-card-body"><h3 class="sign-card-name">' + esc(t.name) + '</h3><p class="sign-card-desc">' + esc(t.desc) + '</p>' +
      '<div class="sign-card-tags">' + tags + '</div><div class="sign-card-btns">' +
      '<button type="button" class="sign-btn-secondary" data-act="designs" data-sign="' + nq + '" data-gallery="' + esc(JSON.stringify(gallery)) + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg> View Designs</button>' +
      '<a class="sign-btn-primary" data-act="flip" href="' + esc(quoteUrl({ type: t.id, category: c.id })) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg> Get Quote</a>' +
      '</div></div></div></div>' +
      '<div class="sign-card-face sign-card-back" aria-hidden="true"><div class="sign-quote-panel">' +
      '<button type="button" class="sign-quote-flipback" data-act="back" aria-label="Back to sign">&larr;</button>' +
      '<form class="sign-quote-form" novalidate>' +
      '<div class="sq-row sq-row-3">' +
      '<div class="sq-field"><label class="sq-lbl" for="sq-name-' + uid + '">Your Name <span class="sq-req" aria-hidden="true">*</span></label><input class="sq-input" id="sq-name-' + uid + '" name="customerName" type="text" autocomplete="name" required aria-required="true" placeholder="e.g. Sarah &ndash; Bloom Bakery"><span class="sq-ferr" role="alert"></span></div>' +
      '<div class="sq-field"><label class="sq-lbl" for="sq-email-' + uid + '">Email Address <span class="sq-req" aria-hidden="true">*</span></label><input class="sq-input" id="sq-email-' + uid + '" name="email" type="email" autocomplete="email" required aria-required="true" placeholder="you@yourbusiness.com"><span class="sq-ferr" role="alert"></span></div>' +
      '<div class="sq-field"><label class="sq-lbl" for="sq-phone-' + uid + '">Phone Number <span class="sq-req" aria-hidden="true">*</span></label><input class="sq-input" id="sq-phone-' + uid + '" name="phone" type="tel" autocomplete="tel" inputmode="tel" required aria-required="true" placeholder="+1 (555) 000-0000"><span class="sq-ferr" role="alert"></span></div>' +
      '</div><div class="sq-row sq-row-2"><div class="sq-field"><label class="sq-lbl" for="sq-text-' + uid + '">Sign Details</label>' +
      '<input class="sq-input" id="sq-text-' + uid + '" name="signText" type="text" placeholder="Sign text, colors, special requirements..."></div></div>' +
      '<div class="sq-row sq-upload-row"><div class="sq-field sq-logo-field"><label class="sq-upload"><input type="file" class="sq-file" name="logo" aria-required="true" accept=".png,.jpg,.jpeg,.svg,image/png,image/jpeg,image/svg+xml">' +
      '<span class="sq-upload-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg></span>' +
      '<span class="sq-upload-txt">Upload Logo <span class="sq-req" aria-hidden="true">*</span></span>' +
      '<span class="sq-upload-sub">PNG, JPG, SVG &middot; Max 10MB</span><span class="sq-upload-name"></span>' +
      '<div class="sq-upload-progress" aria-hidden="true"><div class="sq-upload-progress-track"><div class="sq-upload-progress-bar"></div></div><span class="sq-upload-progress-label"></span></div></label><span class="sq-ferr" role="alert"></span></div>' +
      '<p class="sq-err" role="alert"></p>' +
      '<button type="submit" class="sq-cta">' + arrowR() + ' Get Free Mockup</button></div></form>' +
      '<div class="sign-quote-thanks" aria-hidden="true"><button type="button" class="sq-thanks-back" data-act="done" aria-label="Back to sign">&larr;</button>' +
      '<div class="sq-thanks-hero"><div class="sq-thanks-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg></div>' +
      '<h3 class="sq-thanks-title">We&rsquo;re already <em>on it.</em></h3>' +
      '<p class="sq-thanks-lead">Your request is in. Expect your free mockup within 2 hours.</p>' +
      '<div class="sq-thanks-verify">' +
      '<div class="sq-verify-row"><span class="sq-verify-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22 6 12 13 2 6"/></svg></span>' +
      '<div class="sq-verify-body"><label class="sq-verify-lbl" for="sq-thanks-email-' + uid + '">Email</label><input type="email" class="sq-verify-input js-sq-thanks-email" id="sq-thanks-email-' + uid + '" name="thanks_email" autocomplete="email" placeholder="your@email.com" value=""></div></div>' +
      '<div class="sq-verify-row"><span class="sq-verify-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg></span>' +
      '<div class="sq-verify-body"><label class="sq-verify-lbl" for="sq-thanks-phone-' + uid + '">Phone</label><input type="tel" class="sq-verify-input js-sq-thanks-phone" id="sq-thanks-phone-' + uid + '" name="thanks_phone" autocomplete="tel" placeholder="+1 (555) 000-0000" value=""></div></div>' +
      '</div></div><div class="sq-thanks-tail-spacer" aria-hidden="true"></div></div>' +
      '</div></div></div></div>';
  }
  function signsGrid(c) { return '<div class="signs-grid">' + c.types.map(function (it) { return signCard(it, c); }).join('') + '</div>'; }
  function panelHtml(c) {
    return '<div class="cat-panel-inner"><div class="cat-panel-head">' +
      '<button type="button" class="cat-back-btn" aria-label="Back to categories"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg> Back</button>' +
      '<div class="cat-panel-heading"><h3 class="cat-panel-name">' + esc(c.name) + '</h3><div class="cat-panel-eyebrow">' + esc(c.sub) + '</div>' +
      '<p class="cat-panel-sub">' + esc(c.intro) + '</p></div></div>' +
      '<div class="cat-panel-body">' + signsGrid(c) + '</div></div>';
  }
  /* photos for the moving strip: each sign type's image (category), or a mix across all categories */
  function stripItems(c, limit) {
    var seen = {}, out = [];
    var cats = c ? [c] : DATA.categories;
    var rounds = 0;
    while (out.length < limit && rounds < 12) {
      cats.forEach(function (cat) {
        var it = cat.types[rounds]; if (!it || out.length >= limit) return;
        var t = resolveItem(it);
        if (seen[t.img]) return; seen[t.img] = 1;
        out.push({ key: t.img, label: t.name, sub: cat.name, href: quoteUrl({ type: t.id, category: cat.id }) });
      });
      rounds++;
    }
    return out;
  }
  /* real case study photos (assets/sg-case-strip.js); each one opens its case study (#c-<id>) */
  function caseStripItems(c, limit) {
    var S = window.SG_CASE_STRIP; if (!S) return null;
    var ids = (c && S.cats[c.id]) || S.all, base = URLS.caseStudies || '/pages/case-studies';
    return ids.slice(0, limit).map(function (id) {
      var x = S.items[id];
      DATA.images[x.img] = DATA.images[x.img] || [x.w, x.h];
      return { key: x.img, label: x.label, sub: x.sub + ' · verified buyer', alt: x.alt, href: base + '#c-' + id };
    });
  }
  function stripHtml(items) {
    function cells(dup) {
      var a = dup ? ' tabindex="-1" aria-hidden="true"' : '';
      return items.map(function (x) {
        return '<a class="ps-item" href="' + esc(x.href) + '"' + a + '>' + img(x.key, dup ? '' : x.alt || x.label + ' by Signage.inc', { sm: true, lazy: false }) +
          '<span class="ps-cap">' + esc(x.label) + '<small>' + esc(x.sub) + '</small></span></a>';
      }).join('');
    }
    return '<div class="pstrip" style="--n:' + items.length + '"><div class="ps-track">' + cells(false) + cells(true) + '</div></div>';
  }

  /* =========================================================================
     RENDER
     ========================================================================= */
  function render(root) {
    root = root || doc;
    $$('[data-sg-render="category-grid"]', root).forEach(function (el) {
      var inplace = el.hasAttribute('data-inplace');
      var cards = DATA.categories.map(function (c) { return catCard(c, inplace); }).join('');
      if (!inplace) { el.innerHTML = '<div class="cat-grid">' + cards + '</div>'; return; }
      el.innerHTML = '<div class="cat-viewport"><div class="cat-track">' +
        '<div class="cat-slide cat-slide-grid is-active"><div class="cat-grid">' + cards + '</div></div>' +
        '<div class="cat-slide cat-slide-panel is-hidden"><div class="cat-inline-panel" aria-live="polite"></div></div></div></div>';
      initBrowser(el);
    });

    $$('[data-sg-render="cat-links"]', root).forEach(function (el) {
      /* data-full: "Name / Subtitle" (footer); data-all-label + data-all-href: a last "All Signs" link */
      var full = el.hasAttribute('data-full'), all = el.getAttribute('data-all-label');
      el.innerHTML = DATA.categories.map(function (c) { return '<li><a href="' + esc(catUrl(c)) + '">' + esc(full ? c.name + ' / ' + c.sub : c.name) + '</a></li>'; }).join('') +
        (all ? '<li><a href="' + esc(el.getAttribute('data-all-href') || URLS.categories || '/') + '">' + esc(all) + '</a></li>' : '');
    });

    var needsCat = $$('[data-sg-render="sign-grid"],[data-sg-render="cat-whys"],[data-sg-render="cat-faqs"],[data-sg-tpl],[data-sg-img],[data-sg-href]', root);
    needsCat.forEach(function (el) {
      var c = currentCat(el);
      var mode = el.getAttribute('data-sg-render');
      if (mode === 'sign-grid') { if (c) el.innerHTML = signsGrid(c); }
      else if (mode === 'cat-whys') {
        if (c) el.innerHTML = c.whys.map(function (w) { return '<li>' + CHECK + '<div><b>' + esc(w[0]) + '</b><span>' + esc(w[1]) + '</span></div></li>'; }).join('');
      } else if (mode === 'cat-faqs') {
        if (c) el.innerHTML = c.faqs.map(function (f) { return '<details><summary>' + esc(f[0]) + '</summary><div class="ans"><p>' + esc(f[1]) + '</p></div></details>'; }).join('');
      }
      if (el.hasAttribute('data-sg-tpl')) { el.innerHTML = fill(el.getAttribute('data-sg-tpl'), c); el.classList.add('sg-filled'); }
      if (el.hasAttribute('data-sg-img') && c) {
        var key = c[el.getAttribute('data-sg-img')], d = DATA.images[key] || [];
        if (key) { el.src = imgUrl(key, false); el.alt = c.name + ' by Signage.inc'; if (d[0]) { el.width = d[0]; el.height = d[1]; } el.hidden = false; }
      }
      if (el.hasAttribute('data-sg-href') && c) el.href = quoteUrl({ category: c.id });
    });

    $$('[data-sg-render="strip"]', root).forEach(function (el) {
      var c = el.hasAttribute('data-all') ? null : currentCat(el), limit = +(el.getAttribute('data-limit') || 14);
      if (el.hasAttribute('data-cases')) {
        var items = caseStripItems(c, limit);
        /* the strip data loads after this script: draw the strip once it is there */
        if (!items) {
          var js = doc.getElementById('sg-case-strip-js');
          if (js && !el.dataset.wait) { el.dataset.wait = '1'; js.addEventListener('load', function () { render(el.parentNode); }); }
          return;
        }
        el.innerHTML = stripHtml(items);
      } else el.innerHTML = stripHtml(stripItems(c, limit));
    });

    if (window.SGReveal) window.SGReveal(root);
  }

  /* category page: unknown ?cat sends people to the categories page; otherwise update title + meta */
  function categoryPage() {
    var host = $('[data-sg-category-page]'); if (!host) return;
    var c = currentCat(host);
    if (!c) {
      /* keep the page in the theme editor so it can still be customized */
      if (!(window.Shopify && window.Shopify.designMode)) location.replace(URLS.categories || '/');
      return;
    }
    /* one Shopify page serves every category: title, description, canonical and share tags come from
       the category's metaTitle / metaDesc in assets/sg-sign-categories.js */
    var url = location.origin + (host.getAttribute('data-sg-cat') ? location.pathname : catUrl(c));
    function meta(attr, key, val) {
      var m = $('meta[' + attr + '="' + key + '"]');
      if (!m) { m = doc.createElement('meta'); m.setAttribute(attr, key); doc.head.appendChild(m); }
      m.setAttribute('content', val);
    }
    doc.title = c.metaTitle;
    meta('name', 'description', c.metaDesc);
    meta('property', 'og:title', c.metaTitle);
    meta('property', 'og:description', c.metaDesc);
    meta('property', 'og:url', url);
    meta('name', 'twitter:title', c.metaTitle);
    meta('name', 'twitter:description', c.metaDesc);
    var can = $('link[rel="canonical"]');
    if (!can) { can = doc.createElement('link'); can.rel = 'canonical'; doc.head.appendChild(can); }
    can.href = url;
    var crumb = $('[data-sg-crumb]'); if (crumb) crumb.textContent = c.name;
  }

  /* =========================================================================
     CATEGORY BROWSER (quote page): grid <-> sign types, in place
     ========================================================================= */
  function initBrowser(root) {
    var grid = $('.cat-grid', root), panel = $('.cat-inline-panel', root);
    var gridSlide = $('.cat-slide-grid', root), panelSlide = $('.cat-slide-panel', root);
    var section = root.closest('section') || root, activeId = null;
    function showGrid() { gridSlide.classList.add('is-active'); gridSlide.classList.remove('is-hidden'); panelSlide.classList.add('is-hidden'); panelSlide.classList.remove('is-active'); }
    function showPanel() { panelSlide.classList.add('is-active'); panelSlide.classList.remove('is-hidden'); gridSlide.classList.add('is-hidden'); gridSlide.classList.remove('is-active'); }
    function mark(id) {
      $$('.cat-card', grid).forEach(function (c) {
        var on = c.getAttribute('data-cat') === id;
        c.classList.toggle('is-active', on); c.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    function scrollTop() { var head = $('.s-head', section) || section; head.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    function closePanel() {
      var was = activeId; activeId = null; showGrid(); mark(null);
      setTimeout(function () { if (!panelSlide.classList.contains('is-active')) panel.innerHTML = ''; }, 560);
      var card = was && $('.cat-card[data-cat="' + was + '"]', grid); if (card) card.focus({ preventScroll: true });
    }
    function open(id) {
      if (activeId === id) { closePanel(); return; }
      var c = findCat(id); if (!c) return;
      panel.innerHTML = panelHtml(c);
      activeId = id; mark(id); showPanel(); scrollTop();
      var back = $('.cat-back-btn', panel); if (back) setTimeout(function () { back.focus({ preventScroll: true }); }, 400);
    }
    grid.addEventListener('click', function (e) { var c = e.target.closest('.cat-card'); if (c) open(c.getAttribute('data-cat')); });
    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var c = e.target.closest('.cat-card'); if (!c) return; e.preventDefault(); open(c.getAttribute('data-cat'));
    });
    panel.addEventListener('click', function (e) { if (e.target.closest('.cat-back-btn')) closePanel(); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && activeId && !$('.sign-design-overlay')) closePanel(); });
  }

  /* =========================================================================
     PHONE MASK: +1 (xxx) xxx-xxxx
     The field is never re-read as "all the digits in the box": the 1 of "+1" would then count as part of
     the number and edits near it turn into +1 (111) 111-1111. Instead each edit is worked out by comparing
     the field before and after the keystroke (the text that went in, the text that came out) and applied
     to the 10-digit national number only.
     - "+1 " is always shown in front; a 1 typed or pasted at the start of the number is that country code
       (US area codes never start with 1)
     - backspace / delete on ( ) space - or the +1 removes the digit next to it, never gets stuck
     - the caret stays where the visitor is typing; a full number ignores extra digits
     ========================================================================= */
  var PHONE_MASKED = '.qf-wrap,.sign-quote-form,.csm-form,[data-sg-contact]';
  function isMaskedPhone(el) { return el && el.tagName === 'INPUT' && el.type === 'tel' && el.id !== 'qf-phone' && !!el.closest(PHONE_MASKED); }
  function fmtPhone(d) {
    if (!d) return '';
    if (d.length < 4) return '+1 (' + d;
    if (d.length < 7) return '+1 (' + d.slice(0, 3) + ') ' + d.slice(3);
    return '+1 (' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  /* length of the country-code part at the start ("+1 ", "1", "+1 1"...) */
  function ccLen(s) { var m = /^[^\d]*1+/.exec(s); return m ? m[0].length : 0; }
  function digitsIn(s) { return s.replace(/\D/g, ''); }
  /* national digits of a value, and how many of them sit before position pos */
  function natDigits(s) { return digitsIn(s.slice(ccLen(s))); }
  function natBefore(s, pos) { var c = ccLen(s); return pos <= c ? 0 : digitsIn(s.slice(c, pos)).length; }
  doc.addEventListener('beforeinput', function (e) { if (isMaskedPhone(e.target)) e.target._sgBefore = e.target.value; }, true);
  doc.addEventListener('input', function (e) {
    var el = e.target;
    if (!isMaskedPhone(el)) return;
    var t = e.inputType || '', v = el.value;
    /* the value before this edit: from beforeinput, else what the mask last wrote */
    var old = el._sgBefore != null ? el._sgBefore : (el._sgOut || '');
    el._sgBefore = null;
    var D = natDigits(old);
    /* what changed: old[p, old.length - s) was replaced by v[p, v.length - s).
       The caret marks the end of the edit (everything after it is untouched), so repeated digits like 555
       can't hide which one was typed or deleted; without a caret (autofill) fall back to a plain diff. */
    var p = 0, s = -1, c = el.selectionStart;
    if (c != null && doc.activeElement === el && v.length - c <= old.length && old.slice(old.length - (v.length - c)) === v.slice(c)) s = v.length - c;
    if (s < 0) {
      s = 0;
      var max = Math.min(old.length, v.length);
      while (p < max && old.charAt(p) === v.charAt(p)) p++;
      while (s < max - p && old.charAt(old.length - 1 - s) === v.charAt(v.length - 1 - s)) s++;
    } else {
      var lim = Math.min(c, old.length - s);
      while (p < lim && old.charAt(p) === v.charAt(p)) p++;
    }
    var inserted = v.slice(p, v.length - s);
    var a = natBefore(old, p), b = natBefore(old, old.length - s);
    var ins = digitsIn(inserted);
    if (a === 0) ins = ins.replace(/^1+/, '');      /* country code typed / pasted in front */
    else if (/^[^\d]*\+\s*1/.test(inserted) || (ins.length === 11 && ins.charAt(0) === '1')) ins = ins.slice(1); /* a pasted number carries its own +1 */
    var d, cd;
    if (!ins && a === b && t === 'deleteContentBackward') { d = D.slice(0, Math.max(0, a - 1)) + D.slice(a); cd = Math.max(0, a - 1); }
    else if (!ins && a === b && t === 'deleteContentForward') {
      /* Delete on the "+1" itself does nothing; on ( ) space or - it removes the next digit */
      d = old.length - s <= ccLen(old) ? D : D.slice(0, a) + D.slice(a + 1); cd = a;
    }
    else { d = D.slice(0, a) + ins + D.slice(b); cd = a + ins.length; }
    if (d.length > 10) {
      /* typing into a full number: ignore the extra digit instead of pushing the last one out */
      if (D.length === 10 && (t === 'insertText' || t === 'insertCompositionText')) { d = D; cd = a; }
      else d = d.slice(0, 10);
    }
    cd = Math.min(cd, d.length);
    var out = fmtPhone(d);
    /* only the country code typed so far ("1", "+", "+1 ") */
    if (!out && v && t.indexOf('insert') === 0 && /^[\s+1()-]+$/.test(inserted || v)) out = '+1 ';
    el.value = out;
    el._sgOut = out;
    /* caret right after the same national digit */
    var pos = out.length;
    if (cd < d.length) {
      pos = 4;
      for (var i = 4, n = 0; i < out.length && n < cd; i++) { if (/\d/.test(out.charAt(i))) { n++; pos = i + 1; } }
    }
    try { if (doc.activeElement === el) el.setSelectionRange(pos, pos); } catch (err) { }
  }, true);

  /* =========================================================================
     SIGN CARDS: flip to quote form, thanks panel, designs viewer
     ========================================================================= */
  function setFace(inner, back) {
    inner.classList.toggle('is-flipped', back);
    var f = $('.sign-card-front', inner), b = $('.sign-card-back', inner);
    if (f) { f.setAttribute('aria-hidden', back ? 'true' : 'false'); f.inert = back; }
    if (b) { b.setAttribute('aria-hidden', back ? 'false' : 'true'); b.inert = !back; }
  }
  function resetUpload(panel) {
    $$('.sq-field.sq-bad', panel).forEach(function (fld) { fld.classList.remove('sq-bad'); var o = $('.sq-ferr', fld); if (o) o.textContent = ''; });
    $$('[aria-invalid]', panel).forEach(function (el) { el.setAttribute('aria-invalid', 'false'); });
    $$('.sq-upload', panel).forEach(function (label) {
      label.classList.remove('is-reading', 'has-file');
      var nm = $('.sq-upload-name', label); if (nm) nm.textContent = '';
      var prog = $('.sq-upload-progress', label), bar = $('.sq-upload-progress-bar', label), lbl = $('.sq-upload-progress-label', label);
      if (prog) { prog.classList.remove('sq-upload-progress--active'); prog.setAttribute('aria-hidden', 'true'); }
      if (bar) bar.style.width = '0%';
      if (lbl) lbl.textContent = '';
    });
  }
  function flipOpen(btn) {
    var inner = btn && btn.closest('.sign-card-inner'); if (!inner) return;
    $$('.sign-card-inner.is-flipped').forEach(function (el) { if (el !== inner) setFace(el, false); });
    var panel = $('.sign-quote-panel', inner);
    if (panel) {
      panel.classList.remove('is-thanks');
      var f = $('.sign-quote-form', panel); if (f) f.reset();
      var er = $('.sq-err', panel); if (er) { er.classList.remove('on'); er.textContent = ''; }
      resetUpload(panel);
      var th = $('.sign-quote-thanks', panel); if (th) th.setAttribute('aria-hidden', 'true');
    }
    setFace(inner, true);
    var first = panel && $('input[name="customerName"]', panel);
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
  }
  function flipBack(btn) {
    if (!btn) return;
    var panel = btn.closest('.sign-quote-panel'), inner = btn.closest('.sign-card-inner');
    if (panel) {
      var was = panel.classList.contains('is-thanks');
      var em = $('.js-sq-thanks-email', panel), ph = $('.js-sq-thanks-phone', panel);
      var emailVal = was && em ? em.value.trim() : '', phoneVal = was && ph ? ph.value.trim() : '';
      panel.classList.remove('is-thanks');
      var f = $('.sign-quote-form', panel); if (f) f.reset();
      resetUpload(panel);
      if (was && f) { var a = $('[name="email"]', f), b = $('[name="phone"]', f); if (a) a.value = emailVal; if (b) b.value = phoneVal; }
      var th = $('.sign-quote-thanks', panel); if (th) th.setAttribute('aria-hidden', 'true');
    }
    if (inner) {
      setFace(inner, false);
      var primary = $('[data-act="flip"]', inner); if (primary) primary.focus({ preventScroll: true });
    }
  }

  /* card form: name, email, phone (+1 US) and logo are required; every problem shows under its field at once */
  var SQ_MAX_LOGO = 10 * 1024 * 1024;
  function sqFieldError(el, msg) {
    var fld = el.closest('.sq-field'), out = fld && $('.sq-ferr', fld);
    if (fld) fld.classList.toggle('sq-bad', !!msg);
    el.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (out) out.textContent = msg || '';
  }
  function sqLogoProblem(f) {
    if (!f) return 'Please upload your logo.';
    if (!/\.(png|jpe?g|svg)$/i.test(f.name) && !/^image\/(png|jpeg|svg\+xml)$/.test(f.type)) return 'Please upload a PNG, JPG or SVG file.';
    if (f.size > SQ_MAX_LOGO) return 'Please choose a logo under 10 MB.';
    return '';
  }
  function sqProblems(form) {
    var name = form.elements.customerName.value.trim(), email = form.elements.email.value.trim(), d = form.elements.phone.value.replace(/\D/g, '');
    var file = $('input[type=file]', form);
    return [
      [form.elements.customerName, !name ? 'Please enter your name.' : name.length < 2 ? 'Please enter your full name.' : ''],
      [form.elements.email, !email ? 'Please enter your email address.' : !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email) ? 'Please enter a valid email address.' : ''],
      [form.elements.phone, !d ? 'Please enter your phone number.' : !(d.length === 11 && d.charAt(0) === '1') ? 'Please enter a valid 10-digit US phone number.' : ''],
      [file, sqLogoProblem(file.files && file.files[0])]
    ];
  }
  function submitCard(form) {
    var panel = form.closest('.sign-quote-panel'), wrap = form.closest('.sign-card-wrap');
    var err = $('.sq-err', form), btn = $('.sq-cta', form), file = $('input[type=file]', form);
    err.classList.remove('on'); err.textContent = '';
    var first = null;
    sqProblems(form).forEach(function (x) { sqFieldError(x[0], x[1]); if (x[1] && !first) first = x[0]; });
    if (first) {
      var fld = first.closest('.sq-field');
      if (first.type === 'file') { if (fld) fld.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); first.focus({ preventScroll: true }); }
      else first.focus();
      return;
    }
    var sign = wrap.getAttribute('data-sign') || '';
    var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Sending...';
    window.SGLead.submit({
      name: form.elements.customerName.value.trim(),
      email: form.elements.email.value.trim(),
      phone_number: form.elements.phone.value.trim(),
      details: form.elements.signText.value.trim(),
      sign_types: sign,
      sign_category: wrap.getAttribute('data-cat') || ''
    }, {
      files: file.files && file.files[0] ? [file.files[0]] : [],
      recordSource: 'Sign Type Categories'
    }).then(function () {
      try { history.replaceState(history.state, '', location.pathname + '?thanks-for-response'); } catch (e) { }
      var em = $('.js-sq-thanks-email', panel), ph = $('.js-sq-thanks-phone', panel);
      if (em) em.value = form.elements.email.value.trim();
      if (ph) ph.value = form.elements.phone.value.trim();
      panel.classList.add('is-thanks');
      var th = $('.sign-quote-thanks', panel); if (th) th.setAttribute('aria-hidden', 'false');
    }).catch(function () {
      err.textContent = 'Sorry, that did not send. Please try again or call ' + (SG.phone || '') + '.'; err.classList.add('on');
    }).then(function () { btn.disabled = false; btn.innerHTML = label; });
  }

  function viewDesigns(btn) {
    var wrap = btn.closest('.sign-card-wrap'), name = btn.getAttribute('data-sign') || '', imgs = [];
    try { imgs = JSON.parse(btn.getAttribute('data-gallery') || '[]'); } catch (e) { imgs = []; }
    if (!imgs.length) { var ci = wrap && $('.sign-card-img', wrap); if (ci) imgs = [ci.getAttribute('src')]; }
    if (!imgs.length) return;
    var thumbs = imgs.map(function (u, i) {
      return '<button type="button" class="sdo-thumb' + (i === 0 ? ' is-active' : '') + '" data-idx="' + i + '" aria-label="View image ' + (i + 1) + '"><img src="' + esc(u) + '" alt="" loading="lazy"></button>';
    }).join('');
    var overlay = doc.createElement('div');
    overlay.className = 'sign-design-overlay lp-scope';
    overlay.setAttribute('role', 'dialog'); overlay.setAttribute('aria-modal', 'true'); overlay.setAttribute('aria-label', name + ' designs');
    overlay.innerHTML = '<div class="sdo-inner">' +
      '<button type="button" class="sdo-close" aria-label="Close">✕</button>' +
      '<div class="sdo-head"><span class="sdo-eyebrow">Real Designs We’ve Built</span><h3 class="sdo-title">' + esc(name) + '</h3></div>' +
      '<div class="sdo-stage"><img class="sdo-img" src="' + esc(imgs[0]) + '" alt="' + esc(name) + ' design 1">' +
      '<span class="sdo-counter"><span class="sdo-cur">1</span> / ' + imgs.length + '</span>' +
      (imgs.length > 1 ? '<button type="button" class="sdo-nav sdo-prev" aria-label="Previous image">‹</button><button type="button" class="sdo-nav sdo-next" aria-label="Next image">›</button>' : '') +
      '</div><div class="sdo-thumbs">' + thumbs + '</div>' +
      '<button type="button" class="sdo-quote">' + arrowR() + ' Get a Quote</button></div>';
    doc.body.appendChild(overlay);
    var lastFocus = doc.activeElement;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); $('.sdo-close', overlay).focus(); });
    var main = $('.sdo-img', overlay), cur = $('.sdo-cur', overlay), idx = 0;
    function show(i) {
      idx = (i + imgs.length) % imgs.length; main.src = imgs[idx]; main.alt = name + ' design ' + (idx + 1);
      if (cur) cur.textContent = String(idx + 1);
      $$('.sdo-thumb', overlay).forEach(function (t) {
        var on = Number(t.getAttribute('data-idx')) === idx;
        t.classList.toggle('is-active', on);
        /* keep the active thumbnail visible in the scrolling row */
        if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.offsetLeft - 8, behavior: 'smooth' });
      });
    }
    function close() {
      overlay.classList.remove('is-open'); doc.removeEventListener('keydown', onKey);
      setTimeout(function () { overlay.remove(); }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'Tab') { /* keep focus inside the dialog */
        var f = $$('button', overlay); if (!f.length) return;
        if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.sdo-close')) { close(); return; }
      if (e.target.closest('.sdo-next')) { show(idx + 1); return; }
      if (e.target.closest('.sdo-prev')) { show(idx - 1); return; }
      var th = e.target.closest('.sdo-thumb'); if (th) { show(Number(th.getAttribute('data-idx'))); return; }
      if (e.target.closest('.sdo-quote')) {
        close();
        var primary = wrap && $('[data-act="flip"]', wrap);
        if (primary) setTimeout(function () { flipOpen(primary); }, 230);
      }
    });
    doc.addEventListener('keydown', onKey);
  }

  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var act = b.getAttribute('data-act');
    if (act === 'flip') { e.preventDefault(); flipOpen(b); }
    else if (act === 'back') flipBack(b);
    else if (act === 'done') { var back = b.closest('.sign-quote-panel'); back = back && $('.sign-quote-flipback', back); if (back) flipBack(back); }
    else if (act === 'designs') viewDesigns(b);
  });
  doc.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('.sign-quote-form') : null; if (!f) return;
    e.preventDefault(); submitCard(f);
  });
  /* partial lead capture while typing in a card form */
  doc.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('.sign-quote-form'); if (!f) return;
    /* a field's error goes away as soon as the visitor edits it */
    var fld = e.target.closest('.sq-field');
    if (fld && fld.classList.contains('sq-bad') && e.target.type !== 'file') sqFieldError(e.target, '');
    if (!window.SGLead) return;
    var wrap = f.closest('.sign-card-wrap');
    window.SGLead.savePartial({
      name: f.elements.customerName.value.trim(), email: f.elements.email.value.trim(),
      phone_number: f.elements.phone.value.trim(), details: f.elements.signText.value.trim(),
      sign_types: wrap ? wrap.getAttribute('data-sign') : ''
    });
  });
  doc.addEventListener('change', function (e) {
    var input = e.target; if (!input || input.name !== 'logo' || !input.classList.contains('sq-file')) return;
    var label = input.closest('.sq-upload'), prog = $('.sq-upload-progress', label), bar = $('.sq-upload-progress-bar', label), pct = $('.sq-upload-progress-label', label);
    if (!label || !prog || !bar) return;
    function hide() { label.classList.remove('is-reading'); prog.classList.remove('sq-upload-progress--active'); prog.setAttribute('aria-hidden', 'true'); bar.style.width = '0%'; }
    var file = input.files && input.files[0], nameEl = $('.sq-upload-name', label);
    if (!file) { hide(); if (pct) pct.textContent = ''; if (nameEl) nameEl.textContent = ''; label.classList.remove('has-file'); return; }
    var problem = sqLogoProblem(file);
    if (problem) { input.value = ''; hide(); if (nameEl) nameEl.textContent = ''; label.classList.remove('has-file'); sqFieldError(input, problem); return; }
    sqFieldError(input, '');
    if (nameEl) nameEl.textContent = file.name;
    label.classList.add('has-file');
    label.classList.add('is-reading'); prog.classList.add('sq-upload-progress--active'); prog.setAttribute('aria-hidden', 'false'); bar.style.width = '0%';
    if (pct) pct.textContent = 'Reading… 0%';
    var reader = new FileReader(), saw = false;
    reader.onprogress = function (ev) { if (!ev.lengthComputable || !pct) return; saw = true; var p = Math.min(100, Math.round(ev.loaded / ev.total * 100)); bar.style.width = p + '%'; pct.textContent = 'Reading… ' + p + '%'; };
    reader.onloadstart = function () { if (pct && !saw) pct.textContent = 'Reading…'; };
    reader.onloadend = function () { bar.style.width = '100%'; if (pct) pct.textContent = file.name; setTimeout(hide, 500); };
    reader.onerror = function () { if (pct) pct.textContent = 'Could not read file'; input.value = ''; setTimeout(hide, 1200); };
    reader.readAsArrayBuffer(file);
  });

  /* =========================================================================
     QUOTE FORM (#qfForm, snippets/sg-quote-form.liquid)
     Same behaviour as the Signs.inc form (signs.inc sections/nt-hero-quote-form-v2.liquid):
     - logos upload the moment they are picked (several files, each removable, live progress)
     - first valid submit without a logo or website moves to the "logo phase" instead of sending
     - Indoor / Outdoor can both be selected; mockup cards are multi-select
     - +1 (xxx) xxx-xxxx phone mask, phone must be 11 digits starting with 1
     Differences: the lead goes to the Signage.inc lead API through assets/sg-lead.js (uploaded logo URLs as
     imageUrl); if the upload service fails, the file is sent with the lead itself (no Cloudinary fallback);
     partial leads use the Signage.inc partial-lead API; ?type= / ?category= preselect as before.
     ========================================================================= */
  var IMAGE_UPLOAD_URL = 'https://imagescloudv2.codeblue.agency/api/image/upload';
  var MAX_LOGO_SIZE = 20 * 1024 * 1024;
  var ALLOWED_LOGO_EXT = ['png', 'jpg', 'jpeg', 'svg', 'pdf', 'ai', 'eps'];

  function initQuoteForm() {
    var form = $('#qfForm'), success = $('#qfSuccess');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';

    var nameI = $('#qf-name'), emailI = $('#qf-email'), phoneI = $('#qf-phone'), logoI = $('#qf-logo'), bizI = $('#qf-bizurl');
    var helpName = $('#help-name'), helpEmail = $('#help-email'), helpPhone = $('#help-phone'), helpForm = $('#help-form');
    var submitBtn = $('#qfSubmit'), submitLabel = $('#qfSubmitLabel');
    var contactFields = $('#qf-contact-fields'), sec1 = $('#qf-section-contact'), sec2 = $('#qf-section-details');
    var whyBrand = $('#qf-why-brand'), recBadge = $('#qf-logo-recommended'), orBlock = $('#qf-or-url-block'), gateErr = $('#qf-gate-err-brand');
    var mockupGrid = $('#qf-mockup'), mockupHidden = $('#qf-mockup-val');

    /* ---- mockup cards: multi-select ---- */
    function syncMockups() {
      mockupHidden.value = $$('.qf-mockup-card.sel', mockupGrid).map(function (c) { return c.dataset.val; }).join(', ');
      $$('.qf-mockup-card', mockupGrid).forEach(function (c) { c.setAttribute('aria-pressed', c.classList.contains('sel') ? 'true' : 'false'); });
    }
    function pickMockup(val) {
      var card = $$('.qf-mockup-card', mockupGrid).filter(function (x) { return x.dataset.val === val; })[0];
      if (card) { card.classList.add('sel'); syncMockups(); }
    }
    mockupGrid.addEventListener('click', function (e) {
      var card = e.target.closest('.qf-mockup-card'); if (!card) return;
      card.classList.toggle('sel'); syncMockups();
    });
    mockupGrid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { var card = e.target.closest('.qf-mockup-card'); if (card) { e.preventDefault(); card.click(); } }
    });
    syncMockups();

    /* ---- Indoor / Outdoor: multi-select ---- */
    $$('.qf-toggle-row', form).forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.qf-toggle-btn'); if (!btn) return;
        btn.classList.toggle('sel');
        btn.setAttribute('aria-pressed', btn.classList.contains('sel') ? 'true' : 'false');
      });
    });
    function signPlacement() { return $$('#qf-usage .qf-toggle-btn.sel', form).map(function (b) { return b.dataset.val; }).join(', '); }

    /* ---- validation ---- */
    var isName = function (v) { return v.trim().length >= 2; };
    var isEmail = function (v) { return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v.trim()); };
    var isPhone = function (v) { var d = v.replace(/\D/g, ''); return d.length === 11 && d.charAt(0) === '1'; };

    function validateLive(which) {
      if (which === 'name') {
        var ok = isName(nameI.value);
        nameI.classList.toggle('valid', ok); nameI.classList.toggle('err', !ok && nameI.value.length > 0);
        helpName.classList.remove('err'); helpName.textContent = '';
      }
      if (which === 'email') {
        var okE = isEmail(emailI.value);
        emailI.classList.toggle('valid', okE); emailI.classList.toggle('err', !okE && emailI.value.length > 3);
        if (!okE && emailI.value.length > 3) { helpEmail.classList.add('err'); helpEmail.textContent = 'Double-check that email — looks slightly off.'; }
        else { helpEmail.classList.remove('err'); helpEmail.textContent = ''; }
      }
      if (which === 'phone') {
        var okP = isPhone(phoneI.value), d = phoneI.value.replace(/\D/g, '');
        phoneI.classList.toggle('valid', okP); phoneI.classList.toggle('err', !okP && d.length > 0);
        if (!okP && d.length > 0) { helpPhone.classList.add('err'); helpPhone.textContent = d.length < 10 ? 'US phone numbers are 10 digits.' : ''; }
        else { helpPhone.classList.remove('err'); helpPhone.textContent = ''; }
      }
    }
    /* phone mask: +1 (xxx) xxx-xxxx */
    phoneI.addEventListener('input', function (e) {
      var val = phoneI.value, raw = val.replace(/\D/g, '');
      if (raw.charAt(0) === '1') {
        if (val.indexOf('+1') === 0 || raw.length > 10) raw = raw.slice(1);
        else if (raw === '1') {
          if (e && e.inputType && e.inputType.indexOf('delete') === 0) { phoneI.value = ''; validateLive('phone'); return; }
          raw = '';
        }
      }
      var d = raw.slice(0, 10), out = '';
      if (d.length > 0 || (val.charAt(0) === '1' && raw === '')) {
        out = '+1 ';
        if (d.length > 6) out += '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
        else if (d.length > 3) out += '(' + d.slice(0, 3) + ') ' + d.slice(3);
        else if (d.length > 0) out += '(' + d;
      }
      phoneI.value = out;
      validateLive('phone');
    });
    nameI.addEventListener('input', function () { validateLive('name'); });
    emailI.addEventListener('input', function () { validateLive('email'); });

    /* ---- logos: several files, uploaded instantly ---- */
    var wrap = $('#qfFileWrap'), fMain = $('#qfFileMain'), fHint = $('#qfFileHint'), fClear = $('#qfFileClear'), fList = $('#qfFileList');
    var uProgress = $('#qfUploadProgress'), uBar = $('#qfUploadProgressBar'), uLabel = $('#qfUploadProgressLabel');
    var DEF_MAIN = fMain.innerHTML, DEF_HINT = fHint.textContent;
    var logoFiles = [];      /* { file, status: pending|uploading|done|fallback|invalid, url, reason } */
    var uploadsInFlight = 0, sizeErrorMsg = '';
    var leadUuid = window.SGLead ? window.SGLead.uuid() : '';

    function adjustUploads(delta) {
      uploadsInFlight = Math.max(0, uploadsInFlight + delta);
      submitBtn.disabled = uploadsInFlight > 0;
      uProgress.classList.toggle('active', uploadsInFlight > 0);
    }
    function fmtSize(b) { return b < 1024 ? b + ' B' : b < 1048576 ? (b / 1024).toFixed(1) + ' KB' : (b / 1048576).toFixed(1) + ' MB'; }
    function ext(n) { var m = /\.([a-z0-9]+)$/i.exec(String(n || '')); return m ? m[1].toLowerCase() : ''; }
    function clearLogoAlert() { sec1.classList.remove('logo-alert'); gateErr.textContent = ''; }
    function syncInput() {
      try { var dt = new DataTransfer(); logoFiles.forEach(function (x) { dt.items.add(x.file); }); logoI.files = dt.files; } catch (e) { }
    }
    function uploadedUrls() { return logoFiles.filter(function (x) { return x.status === 'done' && x.url; }).map(function (x) { return x.url; }); }
    function fallbackFiles() { return logoFiles.filter(function (x) { return x.status === 'fallback'; }).map(function (x) { return x.file; }); }
    function hasLogo() { return logoFiles.some(function (x) { return x.status === 'done' || x.status === 'fallback'; }); }
    function render() {
      if (!logoFiles.length) {
        wrap.classList.remove('has-file'); fMain.innerHTML = DEF_MAIN;
        fHint.classList.toggle('err', !!sizeErrorMsg); fHint.textContent = sizeErrorMsg || DEF_HINT;
        fList.innerHTML = ''; return;
      }
      wrap.classList.add('has-file');
      fMain.textContent = logoFiles.length === 1 ? logoFiles[0].file.name : logoFiles.length + ' files selected';
      var anyUp = logoFiles.some(function (x) { return x.status === 'uploading' || x.status === 'pending'; });
      var anyBad = logoFiles.some(function (x) { return x.status === 'invalid'; });
      fHint.classList.toggle('err', !!sizeErrorMsg || (anyBad && !anyUp));
      fHint.textContent = sizeErrorMsg ? sizeErrorMsg : anyUp ? 'Uploading…' : anyBad ? 'Some files were skipped — see details below.' : 'Ready to send';
      fList.innerHTML = logoFiles.map(function (x, i) {
        var cls = x.status === 'done' || x.status === 'fallback' ? 'ok' : x.status === 'invalid' ? 'err' : '';
        var txt = x.status === 'uploading' || x.status === 'pending' ? 'Uploading…' : x.status === 'done' || x.status === 'fallback' ? 'Ready' : esc(x.reason || 'Unsupported file type.');
        return '<div class="qf-file-item"><span class="qf-file-item-name">' + esc(x.file.name) + '</span>' +
          '<span class="qf-file-item-status ' + cls + '">' + txt + '</span>' +
          '<button type="button" class="qf-file-item-remove" data-remove-idx="' + i + '" aria-label="Remove ' + esc(x.file.name) + '">' +
          '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>';
      }).join('');
    }
    function uploadPending() {
      var pending = logoFiles.filter(function (x) { return x.status === 'pending'; });
      if (!pending.length) return;
      pending.forEach(function (x) { x.status = 'uploading'; });
      render(); adjustUploads(1);
      uBar.style.width = '0%'; uLabel.textContent = 'Uploading… 0%';
      var fd = new FormData();
      fd.append('name', nameI.value.trim() || 'lead');
      fd.append('email', emailI.value.trim());
      fd.append('phone', phoneI.value.trim());
      fd.append('business_website', bizI.value.trim());
      fd.append('details', ($('#qf-details').value || '').trim());
      fd.append('estimated_size', ($('#qf-size').value || '').trim());
      fd.append('sign_placement', signPlacement());
      fd.append('signtypes', mockupHidden.value);
      fd.append('page_url', location.href);
      fd.append('uuid', leadUuid);
      pending.forEach(function (x) { fd.append('images[]', x.file); });
      /* the upload service failed: keep the file and send it with the lead instead */
      function fail() { pending.forEach(function (x) { if (x.status !== 'done') x.status = 'fallback'; }); finish(); }
      function finish() { adjustUploads(-1); render(); partial(); }
      var xhr = new XMLHttpRequest();
      xhr.timeout = 45000;
      xhr.upload.onprogress = function (ev) {
        if (!ev.lengthComputable) return;
        var pct = Math.round(ev.loaded / ev.total * 100);
        uBar.style.width = pct + '%'; uLabel.textContent = 'Uploading… ' + pct + '%';
      };
      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) { fail(); return; }
        var urls = [];
        try { urls = (JSON.parse(xhr.responseText) || {}).imageUrls || []; } catch (e) { }
        pending.forEach(function (x, i) { if (urls[i]) { x.status = 'done'; x.url = urls[i]; } else x.status = 'fallback'; });
        finish();
      };
      xhr.onerror = fail; xhr.ontimeout = fail;
      xhr.open('POST', IMAGE_UPLOAD_URL, true);
      xhr.send(fd);
    }
    logoI.addEventListener('change', function () {
      var incoming = logoI.files ? Array.prototype.slice.call(logoI.files) : [];
      if (!incoming.length) return;
      sizeErrorMsg = '';
      var big = incoming.filter(function (f) { return f.size > MAX_LOGO_SIZE; });
      if (big.length) sizeErrorMsg = big.length === 1 ? '"' + big[0].name + '" is ' + fmtSize(big[0].size) + ' — max allowed is 20 MB each.' : big.length + ' files exceed the 20 MB limit and were skipped.';
      incoming.filter(function (f) { return f.size <= MAX_LOGO_SIZE; }).forEach(function (f) {
        if (logoFiles.some(function (x) { return x.file.name === f.name && x.file.size === f.size && x.file.lastModified === f.lastModified; })) return;
        var e = ext(f.name);
        if (ALLOWED_LOGO_EXT.indexOf(e) < 0) {
          logoFiles.push({ file: f, status: 'invalid', url: '', reason: (e ? '"' + e.toUpperCase() + '"' : 'This file type') + ' isn’t supported — use PNG, JPG, SVG, PDF, AI, or EPS.' });
          return;
        }
        logoFiles.push({ file: f, status: 'pending', url: '', reason: '' });
      });
      syncInput(); clearLogoAlert(); render(); uploadPending();
    });
    fList.addEventListener('click', function (e) {
      var b = e.target.closest('[data-remove-idx]'); if (!b) return;
      logoFiles.splice(parseInt(b.getAttribute('data-remove-idx'), 10), 1);
      syncInput(); render();
    });
    fClear.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); logoFiles = []; syncInput(); render(); });
    bizI.addEventListener('input', clearLogoAlert);
    ['dragover', 'dragenter'].forEach(function (ev) { wrap.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.add('drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { wrap.addEventListener(ev, function () { wrap.classList.remove('drag'); }); });
    wrap.addEventListener('drop', function (e) {
      e.preventDefault();
      if (e.dataTransfer.files && e.dataTransfer.files[0]) { logoI.files = e.dataTransfer.files; logoI.dispatchEvent(new Event('change')); }
    });
    function waitUploads() {
      return new Promise(function (resolve) {
        if (!uploadsInFlight) { resolve(); return; }
        var iv = setInterval(function () { if (!uploadsInFlight) { clearInterval(iv); resolve(); } }, 200);
      });
    }

    /* ---- partial lead while typing (Signage.inc partial-lead API) ---- */
    var finalized = false;
    function partial() {
      if (finalized || !window.SGLead) return;
      window.SGLead.savePartial({
        name: nameI.value.trim(), email: emailI.value.trim(), phone_number: phoneI.value.trim(), address: bizI.value.trim(),
        details: ($('#qf-details').value || '').trim(), Size: ($('#qf-size').value || '').trim(),
        sign_usage: signPlacement(), sign_types: mockupHidden.value, imageUrl: uploadedUrls().join(','),
        sign_category: ($('#qf-cat').value || '').trim()
      });
    }
    form.addEventListener('input', partial);
    form.addEventListener('click', function (e) { if (e.target.closest('.qf-toggle-btn,.qf-mockup-card')) partial(); });

    /* ---- ETA countdown on the success panel ---- */
    var etaTimer = null;
    function startEta() {
      var el = $('#sxEta'); if (!el) return;
      var total = 2 * 3600 - 60;
      function tick() {
        if (total <= 0) { el.textContent = 'Any moment now'; clearInterval(etaTimer); return; }
        var h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60);
        el.textContent = h > 0 ? h + 'h ' + m + 'm' : m + 'm'; total -= 60;
      }
      tick(); if (etaTimer) clearInterval(etaTimer); etaTimer = setInterval(tick, 60000);
    }

    /* ---- send ---- */
    function sendLead() {
      var urls = uploadedUrls();
      var skip = emailI.value.trim().toLowerCase().indexOf('fastsigns') > -1;
      return window.SGLead.submit({
        name: nameI.value.trim(),
        email: emailI.value.trim(),
        phone_number: phoneI.value.trim(),
        address: bizI.value.trim() || (hasLogo() ? 'User provided image, please see the Image field' : ''),
        sign_usage: signPlacement(),
        sign_types: mockupHidden.value,
        Size: ($('#qf-size').value || '').trim(),
        details: ($('#qf-details').value || '').trim(),
        sign_category: ($('#qf-cat').value || '').trim(),
        imageUrl: urls.length ? urls.join(',') : undefined
      }, { files: fallbackFiles(), recordSource: 'Landing Page 1', skipConversion: skip });
    }
    function finishSubmit(origLabel) {
      finalized = true;
      $('#sxName').textContent = nameI.value.trim().split(' ')[0] || 'friend';
      $('#sxEmail').textContent = emailI.value.trim() || 'your inbox';
      var sp = $('#sxPhone'); if (sp) sp.textContent = phoneI.value.trim() || 'your phone';
      startEta();
      form.style.display = 'none';
      var unit = form.closest('.qf-card-unit'); if (unit) unit.style.display = 'none';
      success.classList.add('on');
      success.scrollIntoView({ behavior: 'smooth', block: 'start' });
      submitBtn.disabled = false; submitLabel.textContent = origLabel;
    }
    function busy() {
      submitBtn.disabled = true;
      var orig = submitLabel.textContent;
      submitLabel.innerHTML = '<span class="qf-spin" style="margin-right:8px"></span>Sending';
      return orig;
    }
    function send(orig) {
      /* as on Signs.inc: the visitor always gets the success screen; a failed request is logged
         (sg-lead.js reports it) and the URL is marked ?thanks-for-submission */
      return sendLead().then(function () {
        try { history.replaceState(history.state, '', location.pathname + '?thanks-for-response'); } catch (e) { }
        finishSubmit(orig);
      }).catch(function () {
        try { history.replaceState(history.state, '', location.pathname + '?thanks-for-submission'); } catch (e) { }
        finishSubmit(orig);
      });
    }

    var contactPassed = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (helpForm) helpForm.textContent = '';

      /* logo phase: only the logo or website is still needed */
      if (contactPassed) {
        var orig2 = busy();
        waitUploads().then(function () {
          if (!hasLogo() && !bizI.value.trim()) {
            submitBtn.disabled = false; submitLabel.textContent = orig2;
            gateErr.textContent = 'Please upload your logo or enter your website / business name.';
            sec1.classList.add('logo-alert');
            $('#qf-logo-section').scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          send(orig2);
        });
        return;
      }

      validateLive('name'); validateLive('email'); validateLive('phone');
      /* show every contact error at once, then focus the first invalid field */
      var firstBad = null;
      if (!isName(nameI.value)) { nameI.classList.add('err'); helpName.classList.add('err'); helpName.textContent = 'Please enter your name.'; firstBad = firstBad || nameI; }
      if (!isEmail(emailI.value)) { emailI.classList.add('err'); helpEmail.classList.add('err'); helpEmail.textContent = 'Please enter a valid email.'; firstBad = firstBad || emailI; }
      if (!isPhone(phoneI.value)) { phoneI.classList.add('err'); helpPhone.classList.add('err'); helpPhone.textContent = 'Please enter a valid 10-digit phone number.'; firstBad = firstBad || phoneI; }
      if (firstBad) { firstBad.focus(); return; }

      var orig = busy();
      waitUploads().then(function () {
        if (hasLogo() || bizI.value.trim()) { send(orig); return; }
        /* first valid submit without a logo: nothing is sent yet, the form asks for the logo or website */
        submitBtn.disabled = false; submitLabel.textContent = orig;
        contactPassed = true;
        contactFields.style.transition = 'opacity .25s'; contactFields.style.opacity = '0';
        setTimeout(function () { contactFields.hidden = true; }, 250);
        sec1.classList.add('logo-alert');
        whyBrand.hidden = false; recBadge.hidden = false; orBlock.hidden = false;
        var usageF = $('#qf-usage-field'), mockF = $('#qf-mockup-field'), sizeF = $('#qf-size-field'), detF = $('#qf-details-field');
        var u = !!signPlacement(), m = !!mockupHidden.value, s = !!$('#qf-size').value.trim(), dd = !!$('#qf-details').value.trim();
        if (u) usageF.hidden = true; if (m) mockF.hidden = true; if (s) sizeF.hidden = true; if (dd) detF.hidden = true;
        if (u && m && s && dd) sec2.hidden = true;
        setTimeout(function () { $('#qf-logo-section').scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 100);
      });
    });

    $('#sxReset').addEventListener('click', function () {
      if (etaTimer) clearInterval(etaTimer);
      form.reset();
      contactPassed = false; finalized = false;
      leadUuid = window.SGLead ? window.SGLead.uuid() : '';
      [nameI, emailI, phoneI].forEach(function (el) { el.classList.remove('valid', 'err'); });
      logoFiles = []; sizeErrorMsg = ''; syncInput(); render();
      [helpName, helpEmail, helpPhone].forEach(function (h) { h.classList.remove('err'); h.textContent = ''; });
      sec1.classList.remove('logo-alert');
      contactFields.hidden = false; contactFields.style.opacity = '1';
      whyBrand.hidden = true; recBadge.hidden = true; orBlock.hidden = true; gateErr.textContent = '';
      sec2.hidden = false;
      ['#qf-usage-field', '#qf-mockup-field', '#qf-size-field', '#qf-details-field'].forEach(function (id) { $(id).hidden = false; });
      $$('#qf-usage .qf-toggle-btn.sel, #qf-mockup .qf-mockup-card.sel', form).forEach(function (el) { el.classList.remove('sel'); el.setAttribute('aria-pressed', 'false'); });
      syncMockups();
      form.style.display = '';
      var unit = form.closest('.qf-card-unit'); if (unit) unit.style.display = '';
      success.classList.remove('on');
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* desktop only: focus the first field (on phones the keyboard would pop up) */
    if (window.matchMedia && window.matchMedia('(min-width: 1025px)').matches && !location.hash) {
      setTimeout(function () { nameI.focus({ preventScroll: true }); }, 500);
    }

    /* [data-pick="<sign type id>"] buttons preselect that type and scroll up to the form */
    window.lpPick = function (tid) {
      var t = DATA.types[tid]; if (t && t.mockup) pickMockup(t.mockup);
      var box = $('#qf'); if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { if (form.style.display !== 'none') nameI.focus({ preventScroll: true }); }, 700);
    };

    /* ?type=<sign type id> preselects the closest mockup, ?category=<id> is attached to the request */
    if (window.URLSearchParams) {
      var p = new URLSearchParams(location.search), t = p.get('type'), c = findCat(p.get('category'));
      if (t && DATA.types[t] && DATA.types[t].mockup) pickMockup(DATA.types[t].mockup);
      if (c) $('#qf-cat').value = c.name;
      if (t || c) { var box = $('#qf'); if (box) setTimeout(function () { box.scrollIntoView({ block: 'start' }); }, 50); }
    }
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pick]'); if (!b) return;
    if (window.lpPick) { e.preventDefault(); window.lpPick(b.getAttribute('data-pick') || ''); }
  });

  /* =========================================================================
     BOOT
     ========================================================================= */
  window.SGSigns = { data: DATA, findCat: findCat, currentCat: currentCat, catUrl: catUrl, quoteUrl: quoteUrl, imgUrl: imgUrl, render: render };
  categoryPage();
  render(doc);
  initQuoteForm();
  doc.addEventListener('shopify:section:load', function (e) { render(e.target); initQuoteForm(); });
})();
